/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserClassGroupRead
 */
export interface UserClassGroupRead {
    /**
     * 
     * @type {string}
     * @memberof UserClassGroupRead
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserClassGroupRead
     */
    organization_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserClassGroupRead
     */
    deleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserClassGroupRead
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof UserClassGroupRead
     */
    created_on: Date;
    /**
     * 
     * @type {string}
     * @memberof UserClassGroupRead
     */
    created_by: string;
}

/**
 * Check if a given object implements the UserClassGroupRead interface.
 */
export function instanceOfUserClassGroupRead(value: object): value is UserClassGroupRead {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('created_on' in value) || value['created_on'] === undefined) return false;
    if (!('created_by' in value) || value['created_by'] === undefined) return false;
    return true;
}

export function UserClassGroupReadFromJSON(json: any): UserClassGroupRead {
    return UserClassGroupReadFromJSONTyped(json, false);
}

export function UserClassGroupReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserClassGroupRead {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'organization_id': json['organization_id'],
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'id': json['id'],
        'created_on': (new Date(json['created_on'])),
        'created_by': json['created_by'],
    };
}

export function UserClassGroupReadToJSON(json: any): UserClassGroupRead {
    return UserClassGroupReadToJSONTyped(json, false);
}

export function UserClassGroupReadToJSONTyped(value?: UserClassGroupRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'organization_id': value['organization_id'],
        'deleted': value['deleted'],
        'id': value['id'],
        'created_on': ((value['created_on']).toISOString()),
        'created_by': value['created_by'],
    };
}

